import { useState } from "react";
import { Actions, windowReducer, ManagedWindow, WindowStateActions } from "./WindowState";
import { initialWindowState, windowContext } from "./windowContext";
import { useWindowContext } from "./useWindowContext";

export function WindowManager(props: { children: any }) {
  let [state, _dispatch] = useState<ManagedWindow[]>(initialWindowState);

  function dispatch(action: Actions) {
    _dispatch(a => windowReducer({ windows: a }, action).windows);
  }

  return (
    <windowContext.Provider value={{ state, dispatch }}>
      {props.children}
    </windowContext.Provider>
  );
}

export function WindowManagerPopup(props: { children: React.ReactNode }) {
  const { state, dispatch } = useWindowContext();

  return (
    <windowContext.Provider value={{ state, dispatch: popout(dispatch) }}>
      {props.children}
    </windowContext.Provider>
  );
}

function popout(dispatch: React.Dispatch<Actions>): React.Dispatch<Actions> {
  return (action: Actions) => {
    if (action.type === WindowStateActions.Open) {
      dispatch({ ...action, type: WindowStateActions.OpenAsPopup, asPopup: true });
    } else {
      dispatch(action);
    }
  }
}